import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { MFormCurrencyField, MFormTextField, MTypography } from 'src/lib';
import { Color, Display, FlexDirection, Image, Spacing } from 'src/styles';

import * as Styles from '../../NewTransfer.styles';

export interface NewTransferConfirmStepProps {
  type: 'deposit' | 'withdrawal';
  amount: string;
  accountNumber?: string;
  selectedBankAccount: any;
}

export const NewTransferConfirmStep = ({
  amount,
  selectedBankAccount,
  type,
  accountNumber,
}: NewTransferConfirmStepProps) => {
  const renderSelectedBankAccountType = () => (
    <>
      <span>{selectedBankAccount.tradingBlockACHRelationship.bankAccountType}</span>
      {selectedBankAccount.tradingBlockACHRelationship.nickName && (
        <MTypography
          variant='body2'
          inline>{` (${selectedBankAccount.tradingBlockACHRelationship.nickName})`}</MTypography>
      )}
    </>
  );

  const renderSelectedBankAccount = () => (
    <Col span={24} className={cx(Display.flex, FlexDirection.column)}>
      <div>
        {selectedBankAccount.tradingBlockACHRelationship.bankName}{' '}
        <img
          alt='bankLogo'
          src={
            selectedBankAccount.tradingBlockPlaidInstitution?.logo
              ? `data:image/jpeg;base64,${selectedBankAccount?.tradingBlockPlaidInstitution?.logo}`
              : Image.BankPlaceholder
          }
          className={Styles.bankLogo}
        />
      </div>
      <div>{selectedBankAccount.tradingBlockACHRelationship?.bankAccount} </div>
    </Col>
  );

  return (
    <div>
      <Col span={24}>
        <MFormTextField
          label={
            <Col span={24} className={cx(Display.flex, FlexDirection.column)}>
              <div className={Styles.senderReceiverTopLabel}>FROM</div>
              <div>{type === 'deposit' ? renderSelectedBankAccountType() : 'My IPO'}</div>
            </Col>
          }
          value={type === 'deposit' ? renderSelectedBankAccount() : accountNumber}
        />
      </Col>

      <Col span={24}>
        <MFormTextField
          label={
            <Col span={24} className={cx(Display.flex, FlexDirection.column)}>
              <div className={Styles.senderReceiverTopLabel}>TO</div>
              <div>{type === 'deposit' ? 'My IPO' : renderSelectedBankAccountType()}</div>
            </Col>
          }
          value={type === 'deposit' ? accountNumber : renderSelectedBankAccount()}
        />
      </Col>

      <Col span={24}>
        <MFormCurrencyField label='AMOUNT' value={Number(amount)} testId={'money-transfer-amount'} />
      </Col>

      <Row>
        <Col span={24} className={Spacing.mt16}>
          <MTypography variant='body1' color={Color.Gray7}>
            POLICY
          </MTypography>
        </Col>
      </Row>
      <Row>
        <Col span={24} className={Spacing.mt16}>
          <MTypography
            variant='body1'
            color={Color.Gray7}
            testId={
              type === 'deposit' ? 'money-transfer-text-deposit-policy' : 'money-transfer-text-withdrawal-policy'
            }>
            {type === 'deposit'
              ? 'Once you confirm your transaction, you will be able to cancel it in the time span that the transaction is pending. Once the transaction goes through, you will be able to invest.'
              : 'Once you confirm your transaction, you will be able to cancel it in the time span that the transaction is pending. The amount requested to be withdrawn will typically take 1 to 2 business days to be deposited in your chosen bank account.'}
          </MTypography>
        </Col>
      </Row>
      {type === 'withdrawal' && (
        <Row>
          <Col span={24} className={Spacing.mt16}>
            <MTypography variant='body1' color={Color.Gray7}>
              Once the transaction goes through, it will be deducted from your account value.
            </MTypography>
          </Col>
        </Row>
      )}
      <Row>
        <Col span={24} className={Spacing.mt16}>
          <MTypography variant='body1' color={Color.Gray7}>
            You can read more on transaction policies in the{' '}
            <a
              href={`/faq/#${'Account Information'.toLowerCase().replace(/\s/g, '')}`}
              className={Styles.policyLink}
              target='_blank'
              rel='noreferrer'>
              Bank Accounts & Funding Help Page
            </a>
            .
          </MTypography>
        </Col>
      </Row>
    </div>
  );
};
